// Authentication module - Legacy API authentication replaced by Okta
// This module is maintained for backwards compatibility but no longer used
// All authentication is now handled through Okta Auth Service

const authentication = {
  // Legacy methods - now handled by Okta
  login: () => {
    console.warn(
      'Legacy authentication.login called - use Okta Auth Service instead'
    );
    return Promise.resolve({ error: 'Use Okta authentication' });
  },

  logout: () => {
    console.warn(
      'Legacy authentication.logout called - use Okta Auth Service instead'
    );
    return Promise.resolve({ error: 'Use Okta authentication' });
  },

  validateToken: () => {
    console.warn(
      'Legacy authentication.validateToken called - use Okta Auth Service instead'
    );
    return Promise.resolve({ error: 'Use Okta authentication' });
  },

  refreshToken: () => {
    console.warn(
      'Legacy authentication.refreshToken called - use Okta Auth Service instead'
    );
    return Promise.resolve({ error: 'Use Okta authentication' });
  },
};

export default authentication;
